import { Button, Input, Modal, notification } from '@pankod/refine-antd';
import { useInput } from 'hooks';
import { useState } from 'react';
import { deleteAppInstance } from 'services/app-instance';
import useAppInstanceStore from 'store/useAppInstanceStore';

interface AppInstanceDeleteModalProps {
  appId: string;
  isModalOpen: boolean;
  closeModal: () => void;
}

export const AppInstanceDeleteModal: React.FC<AppInstanceDeleteModalProps> = ({
  appId,
  isModalOpen,
  closeModal,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const nameInput = useInput('');
  const { appInstances, removeAppInstance } = useAppInstanceStore();

  const selectedAppInstance = appInstances.find((app) => app.id === appId);
  const isDeleteButtonDisable = selectedAppInstance?.name !== nameInput.value;

  const handleClose = () => {
    nameInput.reset();
    closeModal();
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await deleteAppInstance(appId);
      removeAppInstance(appId);
    } catch (err: any) {
      console.error(err);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    }
    setIsLoading(false);

    closeModal();
  };

  return (
    <Modal
      title="Delete Setup"
      visible={isModalOpen}
      onOk={handleClose}
      onCancel={handleClose}
      footer={[
        <Button key="back" onClick={handleClose}>
          Keep
        </Button>,
        <Button
          danger
          key="submit"
          type="primary"
          loading={isLoading}
          disabled={isDeleteButtonDisable}
          onClick={handleSubmit}
        >
          Delete
        </Button>,
      ]}
    >
      <>
        <p style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '1rem', userSelect: 'none' }}>
          Confirm deletion of {selectedAppInstance?.name}
        </p>
        <p>Type the setup name</p>
        <Input
          placeholder={selectedAppInstance?.name}
          value={nameInput.value}
          onChange={nameInput.onChange}
        />
      </>
    </Modal>
  );
};
